import React from 'react';
import '../css/PicuPatients.css';
import '../App.css';
import CHOPHeader from './CHOPHeader';
import getPicuPatientFHIR from '../services/getPicuPatientFHIR';
import { withRouter } from './withRouter';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import complete from '../img/green-circle.png';
import CustomDialog from "./CustomDialog";
import WriteToLog from '../services/WriteToLog';
import getOAuthAccessToken from "../services/getOAuthAccessToken";
import PicuHeader from './PicuHeader';
import 'url-search-params-polyfill';

class PicuPatient extends React.Component {
  state = { patient: null, unitname: null, error: null };
  
  async componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    const code = query.get('code');
    const state = query.get('state');

    let accessTokenResponse = await getOAuthAccessToken(code, state);
    WriteToLog("Inside PicuPatient - After getOAuthAccessToken: " + JSON.stringify(accessTokenResponse));

    let selectedPatient;
    if (accessTokenResponse && accessTokenResponse !== "token expired") {
      selectedPatient = await getPicuPatientFHIR(accessTokenResponse);
      //console.log(JSON.stringify(selectedPatient));

      if (selectedPatient.error === "") {
        this.setState({ patient: selectedPatient, unitname: selectedPatient.NURSING_UNIT });
      } else {
        console.log(selectedPatient.error);
        this.setState({ error: selectedPatient.error });
      } 
    }
  }

  routePatient = async (patient, nextPage) => {
    if (patient) {
      if (nextPage === "plan") {
        this.props.navigate('/assessment', { state:{selectedPatient: patient}, replace:true } );
      }

      if (nextPage === "intubate") {
        this.props.navigate('/timeout', { state:{selectedPatient: patient}, replace:true } );
      }

      if (nextPage === "debrief") {
        this.props.navigate('/debrief', { state:{selectedPatient: patient}, replace:true } );
      }
    } else {
      // Error page
      WriteToLog("PicuPatient.routePatient: error routing patient to Plan/Timeout ");
      this.props.navigate('/error', { state: {selectedPatient : patient, failure: "while routing patient to Plan/Timeout" } });
    }
  }
  
  render() {
    const { patient, unitname, error } = this.state;

    if (error) {
      return (
        <div className='RiskAssessment'>
          <CHOPHeader />
          <PicuHeader />  
          <div className='left-space'>
            <h3 className="red-font">Something went wrong!</h3>
            <p>An error occurred in the application when trying to build Patient object.</p>
          </div>    
        </div>
      )
    }

    return patient == null ? "Loading..." : 
    <div className="PicuPatients">
      <CHOPHeader/>
      <span><hr></hr></span>
      <h2>{unitname}</h2> 

      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow style={{ padding: "16px 10px" }}>
            <TableCell style={{ fontSize: "18px" }} >Room
            </TableCell>
            <TableCell style={{ fontSize: "18px" }}>Patient</TableCell>
            <TableCell></TableCell>
            <TableCell style={{ fontSize: "18px" }}>Status</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>       
            <TableRow
              key={patient.ROOM_BED}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row" style={{ fontSize: "18px", padding: "16px 10px"  }}>
                {patient.ROOM} {patient.BED}
              </TableCell>
              <TableCell style={{ fontSize: "18px", padding: "16px 10px"  }}><b>{patient.DISPLAY_NAME}</b> <br></br>{patient.MRN}</TableCell>
              <TableCell style={{ fontSize: "16px", padding: "16px 10px"  }}>
              {patient.PLAN_STATUS === "Plan Complete" ? (
                <div><img src={complete} alt=""></img><span>&nbsp;Plan Complete</span><br></br><span className="grey-font">&nbsp;&nbsp;Updated: {patient.PLAN_COMPLETE_TIMESTAMP}</span></div>
              ) : (
                <div><span>&nbsp;Not Complete</span></div>
              )}
              </TableCell>
              <TableCell style={{ padding: "16px 0px" }}>
                <button onClick={()=>this.routePatient(patient, "plan")} className="plan-btn add-margin-right" id="plan">Plan</button>
                {patient.PLAN_STATUS === "Plan Complete" ? (
                <button onClick={()=>this.routePatient(patient, "intubate")} className="intubate-btn" id="intubate">Intubate</button>) : (
                  <CustomDialog patient={patient} routePatient={this.routePatient} />
                )}
                <button onClick={()=>this.routePatient(patient, "debrief")} className="intubate-btn" id="intubate">Debrief</button>
              </TableCell>
            </TableRow>
        </TableBody>
      </Table>
      </TableContainer>

    </div>
  ;
  }
}

export default withRouter(PicuPatient);
